import React from 'react'

export default function SponsorDetails({ sponsor }) {
  return (
    <div className="border-2 border-muted-500 bg-muted-100 bg-white p-2">
      <form className="flex flex-col gap-4">
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SPONSOR_LOGO"
            >
              شعار الراعي
            </label>
            <img
              className={`h-64 w-64 border-2 border-muted-500 bg-muted-100 object-contain`}
              src={`${process.env.REACT_APP_API_BASE_URL}/storage${sponsor.logo}`}
              alt={`sponsor logo`}
            />
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SPONSOR_BANNER"
            >
              بانر الراعي
            </label>
            <img
              className="h-64 w-full border-2 border-muted-500 bg-muted-100 object-contain"
              src={`${process.env.REACT_APP_API_BASE_URL}/storage${sponsor.banner}`}
              alt={`sponsor banner`}
            />
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SPONSOR_NAME_AR"
            >
              اسم الراعي بالعربية
            </label>
            <div className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none">
              {sponsor.name_ar}
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="line-clamp-1 font-bold"
              htmlFor="ID_SPONSOR_NAME_EN"
            >
              اسم الراعي بالإنجليزية{' '}
            </label>
            <div className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none">
              {sponsor.name_en}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SPONSOR_EMAIL"
            >
              البريد الإلكتروني
            </label>
            <div className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none">
              {sponsor.email}
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SPONSOR_PHONE"
            >
              رقم الهاتف
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.phone}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SPONSOR_COUNTRY"
            >
              الدولة
            </label>
            <div className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none">
              {sponsor.country?.name_ar}
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_YOUTUBE_LINK"
            >
              رابط قناتك على YouTube
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.youtube}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_INSTAGRAM_LINK"
            >
              رابط حسابك على Instagram
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.instagram}
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_FACEBOOK_LINK"
            >
              رابط حسابك على Facebook
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.facebook}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_TWITTER_LINK"
            >
              رابط حسابك على Twitter
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.x}
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_LINKEDIN_LINK"
            >
              رابط حسابك على LinkedIn
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.linkedin}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_WEBSITE_LINK"
            >
              رابط الموقع الإلكتروني
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.website_url}
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SNAPCHAT_LINK"
            >
              رابط حسابك على Snapchat
            </label>
            <div
              dir="ltr"
              className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none"
            >
              {sponsor.snapchat}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="CATEGORY_ID"
            >
              باقة الرعاية
            </label>
            <div className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none">
              {sponsor.sponsor_package.name_ar}
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_SNAPCHAT_LINK"
            >
              النشر
            </label>
            <div className="border-2 border-muted-500 bg-muted-100 p-3 leading-none outline-none">
              {sponsor.is_published ? 'تم النشر' : 'لم يتم النشر'}
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_HISTORY_EN"
          >
            الوصف بالعربية
          </label>
          <div
            className="border-2 border-muted-500 bg-muted-100 p-3"
            dangerouslySetInnerHTML={{
              __html: sponsor.description_ar,
            }}
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_HISTORY_EN"
          >
            الوصف بالإنجليزية
          </label>
          <div
            dir="ltr"
            className="border-2 border-muted-500 bg-muted-100 p-3"
            dangerouslySetInnerHTML={{
              __html: sponsor.description_en,
            }}
          />
        </div>
      </form>
    </div>
  )
}
